import { render, staticRenderFns } from "./staffBoard.vue?vue&type=template&id=c66ef638&scoped=true"
import script from "./staffBoard.vue?vue&type=script&lang=js"
export * from "./staffBoard.vue?vue&type=script&lang=js"
import style0 from "./staffBoard.vue?vue&type=style&index=0&id=c66ef638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66ef638",
  null
  
)

export default component.exports